<template>
    <div>
        <loading v-if="loadingRender"></loading>
        <div class="d-flex justify-content-center">
            <div class="card p-3 m-3 w-100">

                <div class="row" id="ZarinPalTr">

                    <div class="form-group text-right mt-2 mr-3 col-12 col-md-4">
                        <small>شبا</small>
                        <input type="email" class="form-control required" v-model="token">
                    </div>
                    <div class="col-md-2 col-12 mt-2 text-right ">
                        <small>از تاریخ</small>
                        <date-picker :editable="true" :auto-submit="true" color="rgb(94 163 30)" v-model="date"
                            :input-class="'required'">
                        </date-picker>
                        <input type="text" tabindex="-1" class="d-none InputText " style="direction: ltr" />
                    </div>

                    <div class="col-md-2 col-12 mt-2 text-right ">
                        <small>تا تاریخ</small>
                        <date-picker :editable="true" :auto-submit="true" color="rgb(94 163 30)" v-model="todate"
                            :input-class="'required'">
                        </date-picker>
                        <input type="text" tabindex="-1" class="d-none InputText " style="direction: ltr" />
                    </div>

                    <div class="text-right  mt-2 col-md-2 col-12">
                        <small>وضعیت</small>
                        <select class="form-control" v-model="status" aria-label="Default select example">
                            <option value="1">همه</option>
                            <option value="2">تسویه شده</option>
                            <option value="3">تسویه نشده</option>
                        </select>
                    </div>
        

              
                    <!-- <div class="col-md-2 col-12 mt-2 text-right ">
                        <small>پسورد</small>
                        <input type="password" class="form-control required" v-model="pss" autocomplete="false"> 
                    </div> -->

         

                    <div class="col-md-2 col-12 mt-3">
                       <ExcelExport 
              :data="exceltable" 
              worksheet-name="Sheet1"
              @success="handleExcelSuccess"
              @error="handleExcelError"
            >
              <button class="btn btn-outline-success d-none">
                <i class="fas fa-file-excel btn btn-outline-success Pointer d-none" id="DownloadExcel"> دانلود فایل اکسل </i>
              </button>
            </ExcelExport>
                    </div>
                </div>
                <div class="w-25 mr-3">
                    <input type="button" name="" value="جستجو" class="btn btn-success w-100"
                            @click="search()" />
                </div>
            </div>
        </div>
        <div class="card p-3 m-3 d-flex justify-content-center" id="Date2">

            <div class="card mb-2 " >
                <div class="card-body text-right text-success " style="font-size: 18px;">
                    <span >
                        مبلغ کل تراکنش :
                    </span>
                    <span>
                        {{ $Comma3ragham(sumKol) }}
                    </span>
                </div>
            </div>
            <vue-bootstrap4-table :rows="response" :columns="columns" :config="config" :classes="classes"
                :actions="actions" @on-download="Download">
                <template slot="sort-asc-icon">
                    <i class="fa fa-sort-up"></i>
                </template>
                <template slot="sort-desc-icon">
                    <i class="fa fa-sort-down"></i>
                </template>
                <template slot="no-sort-icon">
                    <i class="fa fa-sort"></i>
                </template>
                <template slot="amount" slot-scope="props">
                    {{ $Comma3ragham(props.row.amount) }}
                </template>
                <template slot="empty-results">
                    <p class="text-right">اطلاعاتی یافت نشد</p>
                </template>
            </vue-bootstrap4-table>

            <!-- 
            <button v-if="date != '' & response.notInsertEnteghalDetails.length > 0"
                class="btn btn-primary col-12 col-md-2 mb-3">ثبت
                واریزی های {{ date }} </button> -->

        </div>

    </div>
</template>
<script>
import VueBootstrap4Table from "vue-bootstrap4-table";
import loading from "../Tools/NetPa/Loading.vue";
import jalaali from 'moment-jalaali'
import moment from 'moment'
export default {
    beforeMount() {
        let token = this.$cookies.get('payStartToken')
        if (token != null)
            this.token = token
        this.response = []
    },
    data() {
        return {
            todate: '',
            pss: '336451',
            status:1,
            token: '',
            date: '',
            exceltable: [],
            Iban: '',
            response: [],
            sumKol : 0,
            columns: [{
                label: "id",
                name: "id",
                visibility: false,
            },

            {
                label: "شناسه ی پرداخت",
                name: "OrderId",
            },
            {
                label: "تاریخ",
                name: "date",
                sort: true,
        initial_sort: true, 
        initial_sort_order: "desc"
            },
            {
                label: "ساعت",
                name: "time",
                sort: true,
        initial_sort: true, 
        initial_sort_order: "desc"
            },
            // {
            //     label: "شماره مرجع بانکی",
            //     name: "trackingCode",
            // },
            {
                label: "مبلغ تراکنش",
                name: "amount",
            },
            {
                label: "وضعیت",
                name: "Status",
            },
            {
                label: "تاریخ تسویه",
                name: "updatedDate",
            },


            ],
            actions: [{
                btn_text: "<i style='font-size:15px' class='fas fa-file-excel '>",
                event_name: "on-download",
                class: "btn  mx-2 btn-outline-success rounded btnEXL ",
                event_payload: { msg: "my custom msg", },
            }],
            config: {
                pagination: true,
                pagination_info: false,
                per_page_options: [10, 20, 30, 50, 100],
                show_refresh_button: false,
                show_reset_button: false,
                checkbox_rows: false,
                rows_selectable: true,
                card_title: "",
                card_mode: false,
                global_search: {
                    placeholder: " جستجو",
                    visibility: true,
                    case_sensitive: false,
                    showClearButton: true,
                    searchOnPressEnter: false,
                },
            },
            classes: {
                table: "table-bordered table-striped table-sm ",
            },
            loadingRender: false,
        }
    },
    components: {
        VueBootstrap4Table, loading
    },
    methods: {


        search() {

            if (this.$ValidForm('ZarinPalTr') == false) {
                return;
            }

            let axios = {
                Method: "Post",
                Action: "TransactionService/GetZarinPal?sheba=" + this.token + "&date=" + this.date + "&todate=" + this.todate + "&pss=" + this.pss,
            }
            this.loadingRender = true;
            this.$PostData(axios).then((data) => {
                if (data.isSuccess == false) {
                    this.$mySweetDefaultTost("", data.message, "info", 2000);
                    this.response = []
                    this.loadingRender = false;
                    return
                }

                var dataJson = JSON.parse(data.data)
                console.log(dataJson)
                this.response = []
                dataJson.resource.forEach(x => {
                    this.response.push({
                        amount: x.amount,
                        date: jalaali(moment(x.created_at)).format('jYYYY/jMM/jDD'),
                        time: jalaali(moment(x.created_at)).format('HH:mm:ss'),
                        CardNumber: '',
                        TrackingCode: '',
                        OrderId: x.reference_session?.id,
                        Status: x.status == "REACHED_AMOUNT" ? 'تسویه شده' : 'تسویه نشده',
                        updatedDate: x.status == "REACHED_AMOUNT" ? jalaali(moment(x.updated_at)).format('HH:mm:ss jYYYY/jMM/jDD') : '',
                    })
                })
                if(this.status != 1){
                    let status = this.status == 2 ? 'تسویه شده' : 'تسویه نشده';
                    this.response = this.response.filter(x=> x.Status == status)
                }
                this.sumKol = 0
                this.response.forEach(x=> {
                    this.sumKol += x.amount
                })
                this.loadingRender = false;
            }).catch(err => {
                this.$mySweetDefaultTost("", "خطا در سرور", "error", 2000);
                this.loadingRender = false;
                throw err
            }).finally(() => {
            })

        },

        Download() {
            console.log('Download')
            this.exceltable = [];
            this.response.forEach(x => {
                var excelrow = {
                    "شناسه ی پرداخت": x.OrderId,
                    "تاریخ": x.date,
                    "مبلغ تراکنش": x.amount,
                    "وضعیت": x.Status,
                    "تاریخ تسویه": x.updatedDate,
                };
                this.exceltable.push(excelrow);
            })
            document.getElementById("DownloadExcel").click();
        },
    }
}
</script>
<style scoped></style>